/**
 * Configuración centralizada de la integración con Apache Superset
 * (dashboard embebido en `features/dashboard`).
 *
 * Usa environment para cambiar entre entornos automáticamente.
 * Vacía por defecto hasta disponer de una instancia real de Superset.
 */

import { environment } from '../../../environments/environment';
import { ApiEndpoints } from './api.config';

export interface SupersetConfig {
  /** Dominio de Superset, con protocolo (ej: https://superset.jrs.gantabi.com) */
  domain: string;
  /** Id del dashboard embebido, generado desde la UI de embedding de Superset */
  dashboardId: string;
  /** Endpoint propio (backend JRS) que emite el guest token de Superset */
  guestTokenEndpoint: string;
}

export const SUPERSET_CONFIG: SupersetConfig = {
  domain: environment.superset.domain,
  dashboardId: environment.superset.dashboardId,
  // Endpoint propio del backend JRS (mismo host/entorno que el resto de la API,
  // ya lleva el bearer token vía authInterceptor). No depende de environment.superset.
  guestTokenEndpoint: ApiEndpoints.superset.guestToken,
};

/**
 * Indica si hay configuración suficiente para intentar embeber el dashboard.
 */
export function isSupersetConfigured(config: SupersetConfig = SUPERSET_CONFIG): boolean {
  return Boolean(config.domain && config.dashboardId && config.guestTokenEndpoint);
}
